var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "benchmark" }, [
    _c("div", { staticClass: "benchmark__head" }, [
      _c("span", [_vm._v(_vm._s(_vm.label))]),
      _c(
        "span",
        { staticClass: "benchmark__mine" },
        [
          _vm.money
            ? _c("hb-money", { attrs: { cents: _vm.mine, size: "sm" } })
            : [_vm._v(_vm._s(_vm.format(_vm.mine)) + _vm._s(_vm.suffix))],
        ],
        2
      ),
    ]),
    _c("div", { staticClass: "benchmark__track" }, [
      _c("div", {
        staticClass: "benchmark__fill",
        style: { width: _vm.minePct + "%" },
      }),
      _c("div", {
        staticClass: "benchmark__average",
        style: { left: _vm.averagePct + "%" },
      }),
    ]),
    _c(
      "div",
      { staticClass: "benchmark__hint" },
      [
        _vm._v(
          " " + _vm._s(_vm.$t("influencer_panel.platform_average")) + ": "
        ),
        _vm.money
          ? _c("hb-money", { attrs: { cents: _vm.average, size: "sm" } })
          : [_vm._v(_vm._s(_vm.format(_vm.average)) + _vm._s(_vm.suffix))],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }